<template>
  <div flat class="align-start d-none d-lg-block">
    <div class="w-100 topbar bg-color-1 d-flex align-center">
    </div>
    <div class="w-100 header bg-white">
      <v-container class="pa-0">
        <v-row class="d-flex">
          <v-col cols="3" class="pa-0 d-flex justify-start align-center">
            <v-btn variant="outlined" rounded="xl" class="text-color-0" @click="$router.push('/')">
              <template v-slot:prepend>
                <v-icon icon="mdi-chevron-left" class="text-color-1"></v-icon>
              </template>
              CONTINUAR COMPRANDO
            </v-btn>
          </v-col>
          <v-col offset="2" cols="2" class="pa-5 d-flex justify-center align-center">
            <v-skeleton-loader :loading="logoImage == null" width="117" height="76" class="logo-supermercado">
              <v-img v-if="logoImage != 'no-image'" :src="logoImage" class="cursor-pointer" alt="Logo"></v-img>
              <v-img v-else src="@/assets/images/logo-supermercado.png" class="cursor-pointer" alt="Logo"></v-img>
            </v-skeleton-loader>
          </v-col>
          <v-col offset="2" cols="3" class="pa-0 d-flex justify-start align-center">
            <v-img src="@/assets/images/logo-oci.png" alt="Logo AWS"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="w-100 menu bg-white text-color-0 d-flex align-center justify-center">
      <b v-if="$route['name'] == 'checkout'">Clique abaixo para finalizar as etapas de sua compra</b>
      <b v-else>Cadastre-se para poder realizar suas compras</b> <span v-if="phone != '' || whatsapp != ''" class="mx-6">|</span> <span v-if="phone != ''">Telefone: <b class="text-color-1">{{ this.phone }}</b></span> <span v-if="phone != '' && whatsapp != ''" class="mx-6">|</span> <span v-if="whatsapp != ''">Whatsapp: <b class="text-color-1">{{ this.whatsapp }}</b></span>
    </div>
  </div>
  <div flat class="align-start d-lg-none mb-2">
    <div class="w-100 topbar-mobile bg-color-1 d-flex align-center">
    </div>
    <div class="w-100 text-xsmall pa-3 bg-white text-color-0 d-flex align-center justify-between">
      <v-row>
          <v-col cols="6" class="d-flex justify-start align-center">
            <v-btn variant="outlined" rounded="xl" size="small" class="text-color-0" @click="$router.push('/')">
              <template v-slot:prepend>
                <v-icon icon="mdi-chevron-left" class="text-color-1"></v-icon>
              </template>
              CONTINUAR COMPRANDO
            </v-btn>
          </v-col>
          <v-col cols="6" class="d-flex justify-start align-center">
            <v-img src="@/assets/images/logo-oci.png" alt="Logo AWS" class="ms-3"></v-img>
          </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Header',
  data() {
    return {
      phone: '',
      whatsapp: ''
    };
  },
  computed: {
    ...mapState('main', {
      logoImage: 'logoImage'
    }),
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig',
      getFooter: 'getFooter'
    }),
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        this.getFooter().then(function(response){
          this.phone = response.phone != null ? response.phone : '';
          this.whatsapp = response.whatsapp != null ? response.whatsapp : '';
        }.bind(this));
      }
    }.bind(this));
  }
};
</script>
